'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _pulse = require('../loaders/pulse');

var _pulse2 = _interopRequireDefault(_pulse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trackerId = _ref.trackerId,
        trackerId = _ref$trackerId === undefined ? 'pulse-view-page' : _ref$trackerId;

    return {
        track: function track(params) {
            var _this = this;

            return new _promise2.default(function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                    var sdk, baseEvent;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (params) {
                                        _context.next = 2;
                                        break;
                                    }

                                    return _context.abrupt('return', reject(new Error('Tracking params must be specified')));

                                case 2:
                                    _context.prev = 2;
                                    _context.next = 5;
                                    return (0, _pulse2.default)({ providerId: params.site, trackerId: trackerId });

                                case 5:
                                    sdk = _context.sent;
                                    baseEvent = {
                                        object: {
                                            contentId: params.pageId,
                                            id: params.pageId,
                                            custom: params.custom,
                                            page_type: params.page_type,
                                            type: 'Page'
                                        },
                                        actor: {
                                            id: params.userId,
                                            realm: params.userRealm
                                        },
                                        provider: {
                                            id: params.site,
                                            product: params.site,
                                            productTag: params.content.productTag,
                                            'spt:engage': params.site.toUpperCase()
                                        }
                                    };


                                    sdk.update(baseEvent);

                                    _context.next = 10;
                                    return sdk.track('trackerEvent');

                                case 10:
                                    return _context.abrupt('return', resolve({
                                        response: 'Pulse page view tracking completed.',
                                        params: params,
                                        trackerId: trackerId
                                    }));

                                case 13:
                                    _context.prev = 13;
                                    _context.t0 = _context['catch'](2);
                                    return _context.abrupt('return', reject(_context.t0));

                                case 16:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this, [[2, 13]]);
                }));

                return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
    };
};
//# sourceMappingURL=page.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/trackers/pulse/view/page.js
 ** module id = 307
 ** module chunks = 0
 **/